export default __webpack_public_path__ + "static/media/Nogg's Needle.c5889733.jpg";